
export default {
  methods: {
    loginWithRedirect: function(redirect) {
      return '/login?redirect=' + encodeURIComponent(redirect)
    },
    registrationRouteWithRedirect: function(redirect) {
      return '/register?redirect=' + encodeURIComponent(redirect)
    },
    getNotificationIcon: function(type) {
      switch (type) {
        case "error":
          return "mdi-alert-circle-outline";
        case "warning":
          return "mdi-alert-outline";
        case "info":
          return "mdi-information-outline";
        case "success":
          return "mdi-check-circle-outline";
        default:
          return "mdi-help";
      }
    },
  }
}
